module.exports = {
	colors: {
		main: '#233654',
		sec: '#2ba14d',
		alt: '#233654',
	},

	showFunds: false,

	showBuses: false,
		
	showHomeworks: true,

	about: {
		mobiles: ['0950032099', '0950032098', '0950032097'],
		phones: [],
		address: '',
		data: [],
		email: null,
		facebook: 'https://www.facebook.com/share/18v8A7BWLy',
		privacy: null,
		details: [],
	},

	pwa: {
		name: 'Edunix - Al-Jenan app',
		shortName: 'Al-Jenan app',
		description: 'Edunix - Al-Jenan app - portal version for Al-Jenan mobile app.',
	},
};
